import { Box, Typography } from '@mui/material'
import React from 'react';
import '../../styles/index.css'

function Bread({phone}) {
  return (
   <Box component={"div"} className='cover' sx={{backgroundImage:'url(/images/factory.png) '}} display={"flex"} flexDirection={"column"} gap={8} p="5% 20px">
      { phone ? 

        <Box position={"relative"} height={"550px"}  display={"flex"}  p="10px" width="100%" justifyContent={"center"}>
            <img src="/images/verticalsnak.png" alt="" style={{position:'absolute',width:'100%'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-duration="1000" />
            <Box display={"flex"}  flexDirection={"column"} justifyContent={"flex-end"} height={"80%"} width="100%"  alignItems={"center"} gap={2} p="10px" position={"absolute"}>
                <h2 style={{textAlign:'center'}}>   کارخانه میکس و بسته بندی مواد اسنک  </h2>
                <Box component={"div"} onClick={()=>window.location.href = 'https://jobs.jansnak.com/'} sx={{color:'#fff',bgcolor:'#000000',borderRadius:'20px',width:"250px",height:"44px",fontSize:'20px',cursor:'pointer'}} display={"flex"} justifyContent={"space-around"} alignItems={"center"}> 
                    <Typography sx={{color:'#fff',fontSize:"15px",cursor:'pointer'}}>   جزئیات بیشتر در مورد امکانات</Typography>
                    <img src="/images/arrowWhite.png" alt="" width={'15px'} />
                </Box>
            </Box>
        </Box>
      : 

      <Box data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100" position={"relative"} height={"300px"} borderRadius={"30px"} display={"flex"} flexDirection={"column"} alignItems={"center"}>
            <img src="/images/mavad.png" alt="" height={"330px"}  style={{position:'absolute',width:'95%'}} />

            <Box display={"flex"}  flexDirection={"column"} justifyContent={"center"} height={"100%"} width="90%"  alignItems={"flex-start"} gap={2}  position={"absolute"} p="30px">
                <h2 style={{textAlign:'right',width:'300px'}}>   کارخانه میکس و بسته بندی مواد اسنک  </h2>
                <Box component={"div"} onClick={()=>window.location.href = 'https://jobs.jansnak.com/'} sx={{color:'#fff',bgcolor:'#000000',borderRadius:'10px',width:"250px",height:"44px",fontSize:'20px',cursor:'pointer'}} display={"flex"} justifyContent={"space-around"} alignItems={"center"}> 
                    <Typography sx={{color:'#fff',fontSize:"15px",cursor:'pointer'}}>   جزئیات بیشتر در مورد امکانات</Typography>
                    <img src="/images/arrowWhite.png" alt="" width={'15px'} />
                </Box>
            </Box>
        </Box>}
        <Box display={"flex"} flexDirection={phone ? "column":"row"}  justifyContent={"space-around"} alignItems={"center"} gap={2}>
            <Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100">
                <img src="/images/refrigerator.png" alt="" width="150px" />
                <h4 style={{width:'250px',textAlign:'center',color:'#fff'}}> سردخانه های زیر صفر و بالای صفر  </h4>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100">
                <img src="/images/dry.png" alt="" width="150px" />
                <h4 style={{width:'250px',textAlign:'center',color:'#fff'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100"> انبار و تجهیزات مواد خشک </h4>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100">
                <img src="/images/lab.png" alt="" width="150px" />
                <h4 style={{width:'250px',textAlign:'center',color:'#fff'}} >  آزمایشگاه تخصصی کنترل کیفیت  </h4>
            </Box>
        </Box>
   </Box>
  )
}

export default Bread